
import api from '../Api'
import {ICollectionResponse} from "../../models/ICollectionResponse";
import {IStorefrontQuestion} from "../../models/Storefront";
import {IActionResponse} from "../../dal/BaseDAL";
import {cloneDeep} from "lodash";

const storefrontQuestionsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getProductQuestions: build.query<ICollectionResponse<IStorefrontQuestion>, { catalog: string, productId: string }>({
            query: (arg) => `storefront/questions/product/${arg.catalog}/${arg.productId}`
        }),
        saveProductQuestion: build.mutation<IActionResponse, {question: IStorefrontQuestion, catalog: string, productId: string, questionId: string}>({
            query: (arg) => ({
                url:  `storefront/questions/product/${arg.catalog}/${arg.productId}/${arg.questionId}`,
                method: 'PUT',
                body: arg.question
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }

                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getProductQuestions', {catalog: arg.catalog, productId: arg.productId}, draft => {
                        const copy = cloneDeep(draft);
                        const index = draft.items?.findIndex(a => a.id && a.id === arg.questionId);
                        if (index !== -1) {
                            copy.items.splice(index, 1, arg.question);
                        }
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        deleteProductQuestion: build.mutation<IActionResponse, {catalog: string, productId: string, questionId: string}>({
            query: (arg) => ({
                url:  `storefront/questions/product/${arg.catalog}/${arg.productId}/${arg.questionId}`,
                method: 'DELETE',
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }

                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getProductQuestions', {catalog: arg.catalog, productId: arg.productId}, draft => {
                        const copy = cloneDeep(draft);
                        const index = draft.items.findIndex(a => a.id && a.id === arg.questionId);
                        if (index !== -1) {
                            copy.items.splice(index, 1)
                        }
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        createProductQuestion: build.mutation<IActionResponse, {question: IStorefrontQuestion, productId: string, catalog: string}>({
            query: (arg) => ({
                url:  `storefront/questions/product/${arg.catalog}/${arg.productId}`,
                method: 'POST',
                body: arg.question
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }

                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getProductQuestions', {catalog: arg.catalog, productId: arg.productId}, draft => {
                        const copy = cloneDeep(draft);

                        if (result.data.id) {
                            arg.question.id = result.data.id;
                        } else {
                            console.warn('No ID returned from API');
                        }
                        copy.items.splice(copy.items.length, 0, arg.question);

                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        
        
        getBundleQuestions: build.query<ICollectionResponse<IStorefrontQuestion>, string>({
            query: (arg) => `storefront/questions/bundle/${arg}`
        }),
        saveBundleQuestion: build.mutation<IActionResponse, {question: IStorefrontQuestion, bundle: string, questionId: string}>({
            query: (arg) => ({
                url:  `storefront/questions/bundle/${arg.bundle}/${arg.questionId}`,
                method: 'PUT',
                body: arg.question
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }

                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getBundleQuestions', arg.bundle, draft => {
                        const copy = cloneDeep(draft);
                        const index = draft.items.findIndex(a => a.id && a.id === arg.questionId);
                        if (index !== -1) {
                            copy.items.splice(index, 1, arg.question);
                        }
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        deleteBundleQuestion: build.mutation<IActionResponse, {bundle: string, questionId: string}>({
            query: (arg) => ({
                url:  `storefront/questions/bundle/${arg.bundle}/${arg.questionId}`,
                method: 'DELETE',
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }

                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getBundleQuestions', arg.bundle, draft => {
                        const copy = cloneDeep(draft);
                        const index = draft.items.findIndex(a => a.id && a.id === arg.questionId);
                        if (index !== -1) {
                            copy.items.splice(index, 1);
                        }
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        createBundleQuestion: build.mutation<IActionResponse, {question: IStorefrontQuestion, bundle: string}>({
            query: (arg) => ({
                url:  `storefront/questions/bundle/${arg.bundle}`,
                method: 'POST',
                body: arg.question
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }

                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getBundleQuestions', arg.bundle, draft => {
                        const copy = cloneDeep(draft);

                        if (result.data.id) {
                            arg.question.id = result.data.id;
                        } else {
                            console.warn('No ID returned from API for new banner');
                        }
                        copy.items.splice(copy.items.length, 0, arg.question);

                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        
        getStorefrontQuestions: build.query<ICollectionResponse<IStorefrontQuestion>, string>({
            query: (arg) => `storefront/questions/storefront/${arg}`
        }),
        deleteStorefrontQuestion: build.mutation<IActionResponse, {storefront: string, questionId: string}>({
            query: (arg) => ({
                url:  `storefront/questions/storefront/${arg.storefront}/${arg.questionId}`,
                method: 'DELETE',
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }
                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getStorefrontQuestions', arg.storefront, draft => {
                        const copy = cloneDeep(draft);
                        const index = draft.items.findIndex(a => a.id && a.id === arg.questionId);
                        if (index !== -1) {
                            copy.items.splice(index, 1);
                        }
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        saveStorefrontQuestion: build.mutation<IActionResponse, {question: IStorefrontQuestion, storefront: string, questionId: string}>({
            query: (arg) => ({
                url:  `storefront/questions/storefront/${arg.storefront}/${arg.questionId}`,
                method: 'PUT',
                body: arg.question
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }
                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getStorefrontQuestions', arg.storefront, draft => {
                        const copy = cloneDeep(draft);
                        const index = draft.items.findIndex(a => a.id && a.id === arg.questionId);
                        if (index !== -1) {
                            copy.items.splice(index, 1, arg.question);
                        }
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        getQuoteRequestQuestions: build.query<ICollectionResponse<IStorefrontQuestion>, string>({
            query: (arg) => `storefront/questions/quoteRequest/${arg}`
        }),
        deleteQuoteRequestQuestion: build.mutation<IActionResponse, {storefront: string, questionId: string}>({
            query: (arg) => ({
                url: `storefront/questions/quoteRequest/${arg.storefront}/${arg.questionId}`,
                method: 'DELETE',
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) return;
                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getQuoteRequestQuestions', arg.storefront, draft => {
                        const copy = cloneDeep(draft);
                        const index = draft.items.findIndex(a => a.id && a.id === arg.questionId);
                        if (index !== -1) copy.items.splice(index, 1);
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        saveQuoteRequestQuestion: build.mutation<IActionResponse, {question: IStorefrontQuestion, storefront: string, questionId: string}>({
            query: (arg) => ({
                url: `storefront/questions/quoteRequest/${arg.storefront}/${arg.questionId}`,
                method: 'PUT',
                body: arg.question
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) return;
                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getQuoteRequestQuestions', arg.storefront, draft => {
                        const copy = cloneDeep(draft);
                        const index = draft.items.findIndex(a => a.id && a.id === arg.questionId);
                        if (index !== -1) copy.items.splice(index, 1, arg.question);
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        createQuoteRequestQuestion: build.mutation<IActionResponse, {question: IStorefrontQuestion, storefront: string}>({
            query: (arg) => ({
                url: `storefront/questions/quoteRequest/${arg.storefront}`,
                method: 'POST',
                body: arg.question
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) return;
                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getQuoteRequestQuestions', arg.storefront, draft => {
                        const copy = cloneDeep(draft);
                        if (result.data.id) arg.question.id = result.data.id;
                        copy.items.splice(copy.items.length, 0, arg.question);
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
        createStorefrontQuestion: build.mutation<IActionResponse, {question: IStorefrontQuestion, storefront: string}>({
            query: (arg) => ({
                url:  `storefront/questions/storefront/${arg.storefront}`,
                method: 'POST',
                body: arg.question
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }
                dispatch(
                    storefrontQuestionsApi.util.updateQueryData('getStorefrontQuestions', arg.storefront, draft => {
                        const copy = cloneDeep(draft);
 
                        if (result.data.id) {
                            arg.question.id = result.data.id;
                        } else {
                            console.warn('No ID returned from API for new banner');
                        }
                        copy.items.splice(copy.items.length, 0, arg.question);
                    
                        Object.assign(draft, copy);
                    })
                );
            }
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetProductQuestionsQuery,
    useGetBundleQuestionsQuery,
    useGetStorefrontQuestionsQuery,
    useGetQuoteRequestQuestionsQuery,
    useSaveStorefrontQuestionMutation,
    useSaveBundleQuestionMutation,
    useSaveProductQuestionMutation,
    useSaveQuoteRequestQuestionMutation,
    useCreateStorefrontQuestionMutation,
    useCreateProductQuestionMutation,
    useCreateBundleQuestionMutation,
    useCreateQuoteRequestQuestionMutation,
    useDeleteStorefrontQuestionMutation,
    useDeleteBundleQuestionMutation,
    useDeleteProductQuestionMutation,
    useDeleteQuoteRequestQuestionMutation,
} = storefrontQuestionsApi
